<div class="container-idle">
	<div class="modal" tabindex="-1" style="justify-content: space-between;">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Información contrato {{newSalary.name}}</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(-1)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm form-group">
							<label for="payment" class="form-label">Periodo de pago</label>
							<select name="payment" id="payment" class="form-select" [(ngModel)]="newSalary.payment">
								<option value="0">Diario</option>
								<option value="1">Semanal</option>
								<option value="2">Catorcenal</option>
								<option value="3">Quincenal</option>
								<option value="4">Mensual</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<label for="journalType" class="form-label">Jornada laboral</label>
							<select name="journalType" id="journalType" class="form-select"
								[(ngModel)]="newSalary.shift">
								<option value="0">Diurna</option>
								<option value="1">Nocturna</option>
								<option value="2">Mixta</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<label for="type" class="form-label">Tipo de contratación</label>
							<select name="type" id="type" class="form-select" [(ngModel)]="newSalary.type">
								<option value="0">Tiempo Completo</option>
								<option value="1">Parcial</option>
							</select>
						</div>
					</div>
					<div class="row">
						<div class="col-sm form-group">
							<label for="relation" class="form-label">Relación de dependencia</label>
							<div class="input-group">
								<input type="number" id="relation" name="relation"
									[(ngModel)]="newSalary.relationAmount" class="form-control">
								<button class="btn" [ngClass]="newSalary['isRelation']?'btn-on':'btn-off'"
									(click)="newSalary['isRelation'] = !newSalary['isRelation']"
									*ngIf="newSalary.relationAmount > 0 "
									[tooltip]="!newSalary['isRelation']?'Habilitar prestaciones':'Deshabilitar prestaciones'">
									<i [ngClass]="newSalary['isRelation']?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
								</button>
							</div>
						</div>
						<div class="col-sm form-group">
							<label for="proAmount" class="form-label">Honorarios profesionales</label>
							<div class="input-group">
								<input type="number" id="proAmount" name="proAmount" [(ngModel)]="newSalary.proAmount"
									class="form-control">
								<button class="btn" [ngClass]="newSalary['isPro']?'btn-on':'btn-off'"
									(click)="newSalary['isPro'] = !newSalary['isPro']" *ngIf="newSalary.proAmount > 0 "
									[tooltip]="!newSalary['isPro']?'Habilitar prestaciones':'Deshabilitar prestaciones'">
									<i [ngClass]="newSalary['isPro']?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
								</button>
							</div>
						</div>
						<div class="col-sm form-group">
							<label for="bonusAmount" class="form-label">Otras bonificaciones</label>
							<div class="input-group">
								<input type="number" id="bonusAmount" name="bonusAmount"
									[(ngModel)]="newSalary.bonusAmount" class="form-control">
								<button class="btn" [ngClass]="newSalary['isBonus']?'btn-on':'btn-off'"
									(click)="newSalary['isBonus'] = !newSalary['isBonus']"
									*ngIf="newSalary.bonusAmount > 0 "
									[tooltip]="!newSalary['isBonus']?'Habilitar prestaciones':'Deshabilitar prestaciones'">
									<i [ngClass]="newSalary['isBonus']?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
								</button>
							</div>
						</div>
					</div>
					<div *ngIf="newSalary.relationAmount || newSalary.proAmount || newSalary.bonusAmount">
						<div class="row">
							<div class="table-responsive">
								<table class="table table-striped">
									<caption>
										Activa o desactiva dando click en el icono <i class="fa fa-toggle-off"></i>/<i
											class="fa fa-toggle-on"></i>
									</caption>
									<thead>
										<tr>
											<th [colSpan]="getColumnSpan()">RESUMEN</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td *ngIf="newSalary.relationAmount > 0">
												<table class="table mb-0">
													<thead>
														<tr>
															<th colspan="2">DESCRIPCION</th>
															<th>PORCENTAJE</th>
															<th>CANTIDAD</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td colspan="2">Relación de dependencia</td>
															<td>100%</td>
															<td>{{newSalary.relationAmount | currency:'Q'}}</td>
														</tr>
														<ng-container *ngIf="newSalary['isRelation']">
															<tr
																[ngClass]="newSalary.rAguinaldo?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.rAguinaldo = !newSalary.rAguinaldo"
																		class="toggle-icon"
																		[ngClass]="newSalary.rAguinaldo?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Aguinaldo</td>
																<td>8.33%</td>
																<td>{{(newSalary.relationAmount*0.0833) | currency:'Q'}}
																</td>
															</tr>
															<tr [ngClass]="newSalary.rBono?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.rBono = !newSalary.rBono"
																		class="toggle-icon"
																		[ngClass]="newSalary.rBono?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Bono 14</td>
																<td>8.33%</td>
																<td>{{(newSalary.relationAmount*0.0833) | currency:'Q'}}
																</td>
															</tr>
															<tr
																[ngClass]="newSalary.rVacaciones?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.rVacaciones = !newSalary.rVacaciones"
																		[ngClass]="newSalary.rVacaciones?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Vacaciones</td>
																<td>4.17%</td>
																<td>{{(newSalary.relationAmount*0.0417) | currency:'Q'}}
																</td>
															</tr>
															<tr [ngClass]="newSalary.rIggs?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.rIggs = !newSalary.rIggs"
																		[ngClass]="newSalary.rIggs?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>IGSS</td>
																<td>4.83%</td>
																<td>{{(newSalary.relationAmount*0.0483) | currency:'Q'}}
																</td>
															</tr>
														</ng-container>
													</tbody>
												</table>
											</td>
											<td *ngIf="newSalary.proAmount > 0">
												<table class="table mb-0">
													<thead>
														<tr>
															<th colspan="2">DESCRIPCION</th>
															<th>PORCENTAJE</th>
															<th>CANTIDAD</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td colspan="2">Honorarios profesionales</td>
															<td>100%</td>
															<td>{{newSalary.proAmount | currency:'Q'}}</td>
														</tr>
														<ng-container *ngIf="newSalary['isPro']">
															<tr
																[ngClass]="newSalary.pAguinaldo?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.pAguinaldo = !newSalary.pAguinaldo"
																		class="toggle-icon"
																		[ngClass]="newSalary.pAguinaldo?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Aguinaldo</td>
																<td>8.33%</td>
																<td>{{(newSalary.proAmount*0.0833) | currency:'Q'}}
																</td>
															</tr>
															<tr [ngClass]="newSalary.pBono?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.pBono = !newSalary.pBono"
																		class="toggle-icon"
																		[ngClass]="newSalary.pBono?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Bono 14</td>
																<td>8.33%</td>
																<td>{{(newSalary.proAmount*0.0833) | currency:'Q'}}
																</td>
															</tr>
															<tr
																[ngClass]="newSalary.pVacaciones?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.pVacaciones = !newSalary.pVacaciones"
																		[ngClass]="newSalary.pVacaciones?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Vacaciones</td>
																<td>4.17%</td>
																<td>{{(newSalary.proAmount*0.0417) | currency:'Q'}}
																</td>
															</tr>
														</ng-container>
													</tbody>
												</table>
											</td>
											<td *ngIf="newSalary.bonusAmount > 0">
												<table class="table mb-0">
													<thead>
														<tr>
															<th colspan="2">DESCRIPCION</th>
															<th>PORCENTAJE</th>
															<th>CANTIDAD</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td colspan="2">Otras bonificaciones</td>
															<td>100%</td>
															<td>{{newSalary.bonusAmount | currency:'Q'}}</td>
														</tr>
														<ng-container *ngIf="newSalary['isBonus']">
															<tr
																[ngClass]="newSalary.bAguinaldo?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.bAguinaldo = !newSalary.bAguinaldo"
																		class="toggle-icon"
																		[ngClass]="newSalary.bAguinaldo?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Aguinaldo</td>
																<td>8.33%</td>
																<td>{{(newSalary.bonusAmount*0.0833) | currency:'Q'}}
																</td>
															</tr>
															<tr [ngClass]="newSalary.bBono?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.bBono = !newSalary.bBono"
																		class="toggle-icon"
																		[ngClass]="newSalary.bBono?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Bono 14</td>
																<td>8.33%</td>
																<td>{{(newSalary.bonusAmount*0.0833) | currency:'Q'}}
																</td>
															</tr>
															<tr
																[ngClass]="newSalary.bVacaciones?'toggle-on':'toggle-off'">
																<td><i (click)="newSalary.bVacaciones = !newSalary.bVacaciones"
																		[ngClass]="newSalary.bVacaciones?'fa fa-toggle-on':'fa fa-toggle-off'"></i>
																</td>
																<td>Vacaciones</td>
																<td>4.17%</td>
																<td>{{(newSalary.bonusAmount*0.0417) | currency:'Q'}}
																</td>
															</tr>
														</ng-container>
													</tbody>
												</table>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr>
											<td colspan="3" class="td-center">Total {{ newSalary.proAmount +
												newSalary.relationAmount + newSalary.bonusAmount | currency: 'Q'}}</td>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="display: flex; justify-content: space-between; margin-top: 1em;">
					<div class="input-group">
						<label for="profileName" class="input-group-text" *ngIf="isCreating">Nombre del perfil</label>
						<input *ngIf="isCreating" type="text" id="profileName" name="profileName" class="form-control"
							[(ngModel)]="newSalary.name">
						<button class="btn btn-success" (click)="saveProfileContract()" [disabled]="loading">
							<i *ngIf="!loading" class="fa fa-save"></i>
							<span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>{{ isCreating ? 'GUARDAR' : 'ACTUALIZAR' }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>